export default __webpack_public_path__ + "static/TileMenu_Verical-77369fc01283b7ed0c7df48a6cd47422.png";